<template>
    <div>
    <target-div ref="tableData1" />
    <target ref="tableData2"/>
    </div>
</template>
<script>
import { addOrUpdateTargetApi } from "@/api/saleTaskCollection";
import targetDiv from "./target.vue";
import target from "./target.vue";
export default {
  components: {
    targetDiv,target
  },
  data(){
    return {
  
    }
  },
  methods:{
    init(data,queryParams) {
        let tableData1=[]
        let tableData2=[]
        data?.map(m=>{
          if(m.orderType==0){
            tableData1.push(m)
          }else{
            tableData2.push(m)
          }
        })
        this.$nextTick(()=>{
          this.$refs.tableData1.init(tableData1,queryParams,1)
          this.$refs.tableData2.init(tableData2,queryParams,2)
        })
        
      },
            // 保存
    async handleSave(params) {
      let tableData = [...this.$refs.tableData1.getData(),...this.$refs.tableData2.getData()]
        try {
          const submitData = {
            ...params,
            dataList: tableData
          };
          const res = await addOrUpdateTargetApi(submitData);
          if (res.status == 0) {
            let tableData1=[]
            let tableData2=[]
            res.data.map(m=>{
              if(m.orderType==0){
                tableData1.push(m)
              }else{
                tableData2.push(m)
              }
            })
            this.$nextTick(()=>{
              this.$refs.tableData1.init(tableData1,params,1)
              this.$refs.tableData2.init(tableData2,params,2)
            })

            
            this.$DonMessage.success("操作成功！");
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      }
  }
}
</script>